export const research = [
  {
    id: "uf-ops",
    title: "Update-Free On-Policy Steering via Verifiers",
    venue: "arXiv:2603.10282",
    year: "2026",
    link: "https://arxiv.org/abs/2603.10282",
    // As listed on arXiv
    authors: [
      "Maria Attarian",
      "Ian Vyse",
      "Jasper Gerigk",
      "Evgenii Opryshko",
      "Yifan Ruan",
      "Anas Almasri",
      "Sumeet Singh",
      "Yilun Du",
      "Igor Gilitschenski",
      "Claas Voelcker"
    ],
    description: "Test-time steering of diffusion/flow robot policies using verifiers trained on the policy's own rollouts. ~49% average success-rate improvement across 5 real ALOHA tasks with no policy fine-tuning."
  },
  {
    id: "rational-maps",
    title: "Real Two-Dimensional Rational Maps",
    venue: "In preparation",
    year: "May 2026 - Present",
    lab: "Research Opportunity Program (MAT299)",
    description: "Dynamics of a two-parameter planar rational map, supervised by Prof. Nadya Askaripour. Rigorous proofs on orbits and global stability, validated with Python simulations and phase portraits. Journal paper in preparation with Prof. Askaripour and two student coauthors."
  }
];
